<template>
  <transition-group name='fade'>
    <div @click="defaultMask" @touchmove.prevent class="mask" key="1" v-if="show"></div>
    <div class="pop" key="2" v-show="show"  >
      <div style="overflow:auto;">
        <div class="block">
          <el-date-picker
            @change="selectTime"
            v-model="value1"
            type="datetimerange"
            range-separator=""
            :editable="false"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
    </div>
  </transition-group>
</template>

<script>
  import moment from "moment";
  export default {
    name: 'timeDialog',
    components: {},
    data() {
      return {
        show: false,
        value1:[moment().format("YYYY-MM-DD 00:00"), moment().subtract(-1, "days").format("YYYY-MM-DD 00:00")],
      }
    },

    mounted() {
      if (window.history && window.history.pushState) {
        window.addEventListener("popstate", this.onCloseModal, false);
      }
    },

    destroyed() {
      window.removeEventListener("popstate", this.onCloseModal, false);
    },

    methods: {

      onCloseModal() {
        this.show = false;
      },

      defaultMask() {
        this.show = false;
      },
      selectTime(val) {
        if (val !== null) {
          //开始时间
          let startTime = new Date(val[0]).getTime();
          //结束时间
          let endTime = new Date(val[1]).getTime();
          this.click(startTime,endTime)
        }
        this.show = false;
      }
    }
  }
</script>

<style lang="less">
  @media screen and (max-width: 500px) {
    // 渐变过渡
    .fade-enter,
    .fade-leave-active {
      opacity: 0;
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.35s;
    }

    .mask {
      background: rgba(0, 0, 0, 0.5);
      position: fixed;
      top: 0;
      z-index: 2000;
      width: 100%;
      height: 100%;
    }

    .pop {
      min-height: 200px;
      min-width: 25%;
      background: #ffffff;
      border-radius: 8px;
      position: fixed;
      top: 15%;
      left: 50%;
      margin-left: -40%;
      z-index: 2001;
    }

    .meun-switch {
      position: fixed;
      top: 69%;
      left: 20%;
      z-index: 2001;
      cursor: pointer;
      width: 20%;
      height: 10%;
      padding: 5px;
      transition: all 0.25s;

      &.leave {
        left: -65px;
      }
      &.active {
        left: 0;
      }
      &:hover {
        transform: scale(1.02);
      }
    }

    .el-input__inner {
      font-size:  2.5vw;
    }

    .el-date-editor--datetimerange.el-input__inner {
      width: 82vw;
      height: 11vw;
    }

    .el-date-range-picker {
      width: 82vw;
      height: 76vw;
    }

    .el-date-range-picker__content {
      height: 69vw;
    }

    .el-date-table td {
      height: 9vw;
    }

    .el-date-table td span {
      width:100px;
      height: 100px;
      line-height: 5vw;
    }

    .el-date-table td span {
      padding-top: 10px;
      font-size: 3.5vw;
    }

    .el-picker-panel {
      line-height: 0.5rem;
    }

    .el-date-range-picker__time-header {
      display: none;
    }

    .el-input--small .el-input__inner {
      height: 8vw;
      width: 19vw;
      font-size: 3vw;
    }

    .el-date-editor .el-range-input {
      width: 100%;
      font-size: 3.5vw;
    }

    .el-picker-panel__icon-btn,
    .el-button--mini,
    .el-button--small,
    .el-date-table,
    .el-date-range-picker__header div{
      font-size: 3.5vw;
    }

    .el-date-range-picker__header {
      margin-top: 1vw;
    }

    .el-date-editor, .el-range__icon {
      display: none;
    }


    .el-time-panel {
      width: 20vw;
      height: 32vw;
    }

    .el-time-panel__content {
      height: 27vw;
    }

    .el-time-spinner {
      height: 20vw;
    }

    .el-time-spinner__wrapper {
      max-height: 25vw;
    }

    .el-time-spinner__item{
      font-size: 2.5vw;
      line-height: 1rem;
      height: 3vw;
    }

    .el-time-panel__btn  {
      font-size: 3vw;
      line-height: 1rem;
      height: 3vw;
      margin-top: -3vw;
    }

    .el-date-editor .el-range__close-icon {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/popup/timeDialog.vue